import { useEffect, useState } from 'react';
import { getHostingPageData } from '../api/hosint-page';
import { getHostingPlans } from "../api/global";
import Loading from '../components/loading';
import Heading from '../components/hosting-page/Heading';
import Plans from '../components/hosting-page/Plans';
import QuestionList from '../components/hosting-page/QuestionList';
import '../stylesheets/hosting.css';

export default function HostingPage() {
  const [loading, setLoading] = useState(true);
  const [hostingHeading, setHostingHeading] = useState(null);
  const [questionData, setQuestionData] = useState(null);
  const [hostingPlans, setHostingPlans] = useState(null);
  const [billingType, setBillingType] = useState("monthly");

  useEffect(() => {
    const loadingData = async () => {
      const data = await getHostingPageData();
      setHostingHeading(data.heading);
      setQuestionData(data.question);
      setHostingPlans(await getHostingPlans());
    };

    loadingData();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (hostingHeading && hostingPlans) {
      setLoading(false);
    }
  }, [hostingHeading, hostingPlans]);

  if (loading) {
    return <Loading />;
  }

  return hostingHeading && hostingPlans && (
    <div className="HostingPage wrapper">
      <Heading hostingHeading={hostingHeading} billingType={billingType} setBillingType={setBillingType} />
      <Plans plans={hostingPlans} billingType={billingType} />
      <QuestionList questionData={questionData} />
    </div>
  )
}